import { LogType } from '../enum';

export interface ILogEntry {
  type: LogType;
  date: Date;
  message: string;
  category?: string;
  tags?: string[];
}